import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { NavigateNextTwoTone } from "@mui/icons-material";
import Button from "../../../views/buttons/Button";
import Card from "../../../views/datacard/Card";
import InputTextField from "../../../views/inputfield/InputTextField";
import { DropZone } from "../../../views/dropzone/DropZone";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { CATCH_MESSAGE, getImage, Logout } from "../../../UtilityFunctions";
import wbApi from "../../../API/wbApi";
import { nanoid } from "@reduxjs/toolkit";
import CustomBreadcrumbs from "../../../Components/breadCrumb/CustomBreadcrumbs";
import CardWrapper from "../../../views/datacard/CardWrapper";
import DropzoneArea from "../../../views/customDropzone/DropzoneArea";
import { CancelConfirmationPrompt, ShowConfirmationPrompt } from "../../../redux/actions/PromptAction";

const EditIndividualEvent = () => {
  const { company_id, auth_token } = useSelector(
    (state: RootState) => state.auth
  );
  const { template_id } = useSelector((state: RootState) => state.template_id);
  const { defaultSectionId } = useSelector(
    (state: RootState) => state.sections
  );



  const navigate = useNavigate();
  const location = useLocation();
  const { param } = useParams();

  const [bannerTitle, setBannerTitle] = useState("");
  const [altText, setAltText] = useState("");
  const [link, setLink] = useState("");
  const [pageTitle, setPageTitle] = useState("");
  const [description, setDescription] = useState<any>("");
  const [selectedEvent, setSelectedEvent] = useState<string>("");
  const [loader, setLoader] = useState<boolean>(false);
  const [seoTitle, setSEOTitle] = useState<any>("");
  const [seoDescription, setSEODescription] = useState<any>("");
  const [eventDescription, setEventDescription] = useState<any>("");
  const [eventTitle, setEventTitle] = useState<any>("");
  const [eventAltText, setEventAltText] = useState<any>("");
  const [bannerFile, setBannerFile] = useState<any[]>([]);
  const [incomingBannerFile, setIncomingBannerFile] = useState<any[]>([]);
  const [inBannerFile, setInBannerFile] = useState<string>("");
  const [eventImageFile, setEventImageFile] = useState<any[]>([]);
  const [incomingeventImageFile, setIncomingEventImageFile] = useState<any[]>([]);
  const [inEventImageFile, setInEventImageFile] = useState<string>("");
  const [refreshList, setRefreshList] = useState<boolean>(false);

  const [hotelId, setHotelId] = useState('')

  const [charCount, setCharCount] = useState({
    child: 0,
    privacy: 0,
    terms_cond: 0,
    cancellation: 0,
  });

  const [update, setUpdate] = useState('')

  const [eventDetails, setEventDetails] = useState<any>(null)

  const dispatch = useDispatch()

  function removeTags(str: String) {
    str = str.toString();
    const finalStr = str.replace(/&nbsp;/g, " ");
    return finalStr.replace(/(<([^>]+)>)/gi, ""); // Regular expression to identify HTML tags in the input string. Replacing the identified,HTML tag with a null string.
  }

  useEffect(() => {
    if (!location) return;
    const { state }: any = location ?? {};
    setSelectedEvent(state.event_title);
  }, [location])

  useEffect(() => {
    fetchSelectedEventData()
  }, [update])

  const fetchSelectedEventData = async () => {
    try {
      const resp = await wbApi.get(`wb-dashboard/fetch-wb-event-details/${company_id}/${template_id}/${param}`)

      if (resp.data.status === 1) {
        setEventDetails(resp.data.event_details)
      }
      else {
        setEventDetails(null)
      }
    }
    catch {
      toast.error(CATCH_MESSAGE)
    }
  }

  const setAllVals = () => {
    setEventTitle(eventDetails.event_title)
    setEventDescription(eventDetails.event_description)
    setEventAltText(eventDetails.event_image_alt)

    setBannerTitle(eventDetails.banner_title)
    setAltText(eventDetails.banner_alt)
    setLink(eventDetails.video_banner_link)
    setPageTitle(eventDetails.page_title)
    setDescription(eventDetails.page_description)

    setSEOTitle(eventDetails.seo_title)
    setSEODescription(eventDetails.seo_description)

    setHotelId(eventDetails.hotel_id);
    setIncomingBannerFile(eventDetails.banner ? [getImage(eventDetails.banner
    )] : eventDetails.video_banner ? [getImage(eventDetails.video_banner)] : [])
    setInBannerFile(eventDetails.banner ? eventDetails.banner : eventDetails.video_banner ? eventDetails.video_banner : "")
    setIncomingEventImageFile(eventDetails.event_image ? [getImage(eventDetails.event_image)] : [])
    setInEventImageFile(eventDetails.event_image)
  }

  const accpBannerFiles = (value: any) => {
    setBannerFile(value);
  };
  const accpEventFiles = (value: any) => {
    setEventImageFile(value);
  };

  const delteBannerFiles = (value: any) => {
    if (value) {
      dispatch(
        ShowConfirmationPrompt(
          `Are you sure want to delete this ?`,
          "DELETE",
          async () => {
            await delteBannerFilesApi();

            dispatch(CancelConfirmationPrompt());
          }
        )
      );
    }
  };

  const delteBannerFilesApi = async () => {
    try {
      let deleteRes = await wbApi.post(
        `/wb/delete-dz-event-detail-banner`,
        {
          company_id: company_id,
          banner_name: inBannerFile,
          template_id: template_id,
          file_type: eventDetails.banner ? "images" : "video",
          id: param,
        }
      );
      if (deleteRes.data.status === 1) {
        toast.success(deleteRes.data.message);
        fetchSelectedEventData();
      } else {
        toast.error(deleteRes.data.message);
        fetchSelectedEventData();
      }
    } catch {
      toast.error(CATCH_MESSAGE);
    }
  };

  const delteEventFiles = (value: any) => {
    if (value) {
      dispatch(
        ShowConfirmationPrompt(
          `Are you sure want to delete this ?`,
          "DELETE",
          async () => {
            await delteEeventImageFilesApi();

            dispatch(CancelConfirmationPrompt());
          }
        )
      );
    }
  };

  const delteEeventImageFilesApi = async () => {
    try {
      let deleteRes = await wbApi.post(
        `/wb/delete-dz-event-image`,
        {
          company_id: company_id,
          image_name: inEventImageFile,
          template_id: template_id,
        }
      );
      if (deleteRes.data.status === 1) {
        toast.success(deleteRes.data.message);
        fetchSelectedEventData();
      } else {
        toast.error(deleteRes.data.message);
        fetchSelectedEventData();
      }
    } catch {
      toast.error(CATCH_MESSAGE);
    }
  };




  useEffect(() => {
    if (!eventDetails) return
    setAllVals()
  }, [eventDetails])




  async function saveHandler() {
    try {
      let bannerResp: any = "";
      let eventImageResp: any = "undefined";
      if (bannerFile.length > 0) {
        bannerResp = await uploadBannerHandler();
      }
      if (eventImageFile.length > 0) {
        eventImageResp = await uploadEventImageHandler();
      }
      await updateExistingEvent(bannerResp, eventImageResp);
    } catch {
      await updateExistingEvent("", "undefined");
    }
  }

  const uploadBannerHandler = async () => {
    if (bannerFile.length === 1) {
      let payload = new FormData();

      payload.append("uploadFile[0]", bannerFile[0]);
      try {
        let uploadRes = await wbApi.post(
          `/wb/upload-page-banner/${company_id}/${template_id}/event_detail_banner`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + auth_token,
            },
          }
        );
        if (uploadRes.data.status === 1) {
          // return uploadRes.data.image_ids
          if (uploadRes.data.image_id.length > 0) {
            return uploadRes.data.image_id[0];
          } else {
            return uploadRes.data.video_id[0];
          }

        } else {
          return "";

        }
      } catch (error: any) {

        if (error.response.status === 401) {
          Logout();
          toast.error("Session Expired");
        } else {
          toast.error(CATCH_MESSAGE);
        }
        return "";
      }

    } else {
      toast.error("Only One Image Allowed");
    }

  };
  const uploadEventImageHandler = async () => {
    if (eventImageFile.length === 1) {


      let payload = new FormData();

      payload.append("uploadFile[0]", eventImageFile[0]);
      try {
        let uploadRes = await wbApi.post(
          `/wb/insert-dz-images/${company_id}/${template_id}/hotelevent`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + auth_token,
            },
          }
        );
        // console.log("uploadRes", uploadRes);
        if (uploadRes.data.status === 1) {
          return uploadRes.data.image_ids;

        } else {
          return "undefined";

        }
      } catch (error: any) {
        if (error.response.status === 401) {
          Logout();
          toast.error("Session Expired");
        } else {
          toast.error(CATCH_MESSAGE);
        }
        return "undefined";
      }

    } else {
      toast.error("Only One Image Allowed");
    }

  };
  const updateExistingEvent = async (banner: any, eventImg: any) => {
    setLoader(true);
    try {
      const payload = {
        banner_alt: altText,
        banner_title: bannerTitle,
        company_id,
        template_id,
        event_description: eventDescription,
        event_image: eventImg ?? 'undefined',
        event_image_alt: eventAltText,
        event_title: eventTitle,
        hotel_id: hotelId,
        id: param,
        page_description: description,
        page_title: pageTitle,
        seo_description: seoDescription,
        seo_title: seoTitle,
        video_banner_link: link,
        video_banner: '',
        banner: banner ?? '',
      }
      const resp = await wbApi.post(`wb/insert-update-wb-event`, payload)

      if (resp.data.status === 1) {
        toast.success(resp.data.message)
        setUpdate(nanoid());
        setLoader(false);
        setRefreshList(!refreshList)
      }
      else {
        setLoader(false);
        toast.error(resp.data.message)
      }
    }
    catch {
      setLoader(false);
      toast.error(CATCH_MESSAGE)
    }
  }




  return (
    <>
      <div className="wb-subheader">

        <CustomBreadcrumbs
          content={[
            {
              label: "Sections",
              href: "/section-default",
            },
            {
              label: `Default Section`,
              href: "/section-default",
            },
            {
              label: " Edit Events",
              href: "/section-default/edit-event-section-details"
            },
            {
              label: `${selectedEvent}`
            }
          ]}
        />
        <div className="wb-subheader-rightsec">
          <Button
            icon="bi bi-arrow-left"
            className="bck-btn"
            handleClick={() => {
              navigate(-1);
            }}
          >
            Back
          </Button>
        </div>
      </div>
      <div className="wb-divider"></div>

      {/*------------------- Main Section----------------- */}
      <CardWrapper className=" mt-4 mb-4 edit-promo-conatiner">
        <div className="edit-aboutus-text-container">
          <InputTextField
            label="Enter Banner Title"
            value={bannerTitle}
            className="edit-aboutus-subheader"
            handleChange={(e) => { setBannerTitle(e.target.value) }}
          />
          <InputTextField
            label="Banner Alt Text"
            value={altText}
            className="edit-aboutus-alt-text"
            handleChange={(e) => { setAltText(e.target.value) }}
          />
        </div>

        <div className="mt-3">
          <InputTextField
            label="Youtube Link"
            value={link}
            className="edit-aboutus-alt-text"
            handleChange={(e) => { setLink(e.target.value) }}
          />
        </div>

        <div className="edit-promo-alt-label mt-3">
          Select Banner Image
        </div>

        <div className="edit__dropzone__container">
          <DropzoneArea
            centerMesage={"Drag your photos or click here(1 Image/Video Only)"}
            incomingfiles={incomingBannerFile}
            dispatchFiles={(val) => accpBannerFiles(val)}
            isDelete={(val) => delteBannerFiles(val)}
            acceptFileExt="image/jpg,image/jpeg,image/png,image/gif"
            refresh={refreshList}
          />
        </div>

        <div className="mt-2">
          <InputTextField
            label="Page Title"
            value={pageTitle}
            className="edit-aboutus-alt-text"
            handleChange={(e) => { setPageTitle(e.target.value) }}
          />
        </div>

        <div className="edit-promo-alt-label mt-3">
          Enter Page Description
        </div>
        <div className="sec-description-editor">
          <CKEditor
            editor={ClassicEditor}
            data={description}
            config={{
              removePlugins: [
                "EasyImage",
                "ImageUpload",
                "MediaEmbed",
                "Table",
              ],
            }}
            onChange={(event: string, editor: any) => {
              const data = editor.getData();
              setDescription(data);
              setCharCount({
                ...charCount,
                terms_cond: removeTags(data).length,
              });
            }}
          />
        </div>

        <div className="mt-3">
          <InputTextField
            label="Seo Title"
            value={seoTitle}
            className="edit-aboutus-alt-text"
            handleChange={(e) => { setSEOTitle(e.target.value) }}
          />
        </div>

        <div className="edit-promo-alt-label mt-3">
          Enter Seo Description
        </div>
        <div className="sec-description-editor">
          <CKEditor
            editor={ClassicEditor}
            data={seoDescription}
            config={{
              removePlugins: [
                "EasyImage",
                "ImageUpload",
                "MediaEmbed",
                "Table",
              ],
            }}
            onChange={(event: string, editor: any) => {
              const data = editor.getData();
              setSEODescription(data);
              setCharCount({
                ...charCount,
                terms_cond: removeTags(data).length,
              });
            }}
          />
        </div>

        <div className="edit-aboutus-text-container mt-3">
          <InputTextField
            label="Event Title"
            value={eventTitle}
            className="edit-aboutus-alt-text"
            handleChange={(e) => { setEventTitle(e.target.value) }}
          />
          <InputTextField
            label="Enter Alt Text"
            value={eventAltText}
            className="edit-aboutus-subheader"
            handleChange={(e) => { setEventAltText(e.target.value) }}
          />
        </div>

        <div className="edit-promo-alt-label mt-3">
          Select Event Image
        </div>

        <div className="edit__dropzone__container">
          <DropzoneArea
            centerMesage={"Drag your photos or click here(1 Image Only)"}
            incomingfiles={incomingeventImageFile}
            dispatchFiles={(val) => accpEventFiles(val)}
            isDelete={(val) => delteEventFiles(val)}
            acceptFileExt="image/jpg,image/jpeg,image/png,image/gif"
            refresh={refreshList}
          />
        </div>

        <div className="edit-promo-alt-label mt-3">
          Enter Event Description
        </div>
        <div className="sec-description-editor">
          <CKEditor
            editor={ClassicEditor}
            data={eventDescription}
            config={{
              removePlugins: [
                "EasyImage",
                "ImageUpload",
                "MediaEmbed",
                "Table",
              ],
            }}
            onChange={(event: string, editor: any) => {
              const data = editor.getData();
              setEventDescription(data);
              setCharCount({
                ...charCount,
                terms_cond: removeTags(data).length,
              });
            }}
          />
        </div>

        <div className="edit-contact-btn-container">
          <Button className="cancel__btn" handleClick={() => navigate(-1)}>Cancel</Button>
          <Button className="savebtn" handleClick={() => saveHandler()} loader={loader}>Save</Button>
        </div>
      </CardWrapper>
    </>
  );
};

export default EditIndividualEvent;
